import { themeCssVar as globalTheme } from '../../utils/theme';

import { TextFieldInputColorProps, TextFieldLabelProps } from './types';

export const TEXT_FIELD_INPUT_QUIET_PROPS: TextFieldInputColorProps = {
  background: globalTheme.color.backgroundTextFieldQuietDefault,
  backgroundDisabled: globalTheme.color.backgroundTextFieldQuietDefault,
  border: globalTheme.color.borderTextFieldQuietDefault,
  borderDisabled: globalTheme.color.borderTextFieldQuietDisabled,
  borderFocus: globalTheme.color.borderTextFieldQuietFocus,
  borderError: globalTheme.color.borderTextFieldQuietError,
  text: globalTheme.color.textTextFieldQuietInputDefault,
  textDisabled: globalTheme.color.textTextFieldQuietInputDisabled,
  textPlaceholder: globalTheme.color.textTextFieldQuietPlaceholderDefault,
  textPlaceholderDisabled: globalTheme.color.textTextFieldQuietPlaceholderDefault,
  focus: globalTheme.color.borderFocusDefault,
};

export const TEXT_FIELD_LABEL_QUIET_PROPS: TextFieldLabelProps = {
  color: globalTheme.color.textFormLabelDefault,
  colorError: globalTheme.color.textTextFieldQuietLabelError,
};

export const TEXT_FIELD_INPUT_LOUD_PROPS: TextFieldInputColorProps = {
  ...TEXT_FIELD_INPUT_QUIET_PROPS,
  background: globalTheme.color.backgroundTextFieldLoudDefault,
  backgroundDisabled: globalTheme.color.backgroundTextFieldLoudDefault,
  border: globalTheme.color.borderTextFieldLoudDefault,
  borderDisabled: globalTheme.color.borderTextFieldLoudDisabled,
  borderFocus: globalTheme.color.borderTextFieldLoudFocus,
  borderError: globalTheme.color.borderTextFieldLoudError,
  text: globalTheme.color.textTextFieldLoudInputDefault,
  textDisabled: globalTheme.color.textTextFieldLoudInputDisabled,
  textPlaceholder: globalTheme.color.textTextFieldLoudPlaceholderDefault,
  textPlaceholderDisabled: globalTheme.color.textTextFieldLoudPlaceholderDefault,
  focus: globalTheme.color.borderFocusDefault,
};

export const TEXT_FIELD_LABEL_LOUD_PROPS: TextFieldLabelProps = {
  color: globalTheme.color.textFormLabelDefault,
  colorError: globalTheme.color.textTextFieldLoudLabelError,
};
